import { didUserForceSendMessage } from '../selectors/telemetryDataSelectors';
import { getPendingPermissionTelemetryErrorCode } from '../utils/getPendingPermissionTelemetryErrorCode';
import { logUsage } from 'owa-analytics';
import { ValidatedAttachmentType } from '../store/schema/ValidatedAttachmentType';
import {
    lazyGetHasSharingIssues,
    lazyGetSharingLinkCountInBody,
} from 'owa-attachment-block-on-send';
import { getRecipientWellsFromComposeViewState } from 'owa-mail-compose-actions/lib/utils/getAllRecipientsAsEmailAddressStrings';
import getCurrentFromAddress from 'owa-mail-compose-actions/lib/utils/getFromAddressFromRecipientWell';
import { getStore as getMailComposeStore } from 'owa-mail-compose-store';

const MAX_NUMBER_OF_LINKS_TO_LOG = 23;

/**
 * If forceSend= true, it means the the user clicked on 'send' or 'send Anyway' and we should log the pending status.
 * If forceSend= false, it means the confirm dialog was displayed in the session, the user clicked 'Don't send', fixed it and sent it again.
 * and we should log if there are currently any link issues.
 */

export async function logPendingPermissionDataPoint(composeId: string) {
    const mailComposeStore = getMailComposeStore();
    const composeViewState = mailComposeStore.viewStates.get(composeId);
    const forceSend: boolean = didUserForceSendMessage(
        composeId,
        ValidatedAttachmentType.PendingPermissions
    );
    let hasLinkIssueData: { anyLinkIssues: boolean | null } = { anyLinkIssues: null };
    let pendingStatusData: { checkPermissionStatus: string | null } = {
        checkPermissionStatus: null,
    };

    const getSharingLinkCountInBody = await lazyGetSharingLinkCountInBody.import();
    const { linkInBodyCount, newLinkCount } = getSharingLinkCountInBody(
        composeViewState?.attachmentWell
    );

    if (forceSend) {
        const checkPermissionStatus = await getPendingPermissionTelemetryErrorCode(composeId);
        pendingStatusData = { checkPermissionStatus: checkPermissionStatus };
    } else if (composeViewState) {
        let getHasSharingIssues = await lazyGetHasSharingIssues.import();
        const anyLinkIssues = await getHasSharingIssues(
            composeViewState.infoBarIds,
            composeViewState.attachmentWell,
            getCurrentFromAddress(composeViewState.toRecipientWell),
            getRecipientWellsFromComposeViewState(composeViewState),
            false /*isCalendar*/,
            false /* logSharingIssueDatapoint */
        );
        hasLinkIssueData = { anyLinkIssues: anyLinkIssues };
    }

    logUsage('PendingPermissionTriggered', {
        forceSend: forceSend,
        ...hasLinkIssueData,
        ...pendingStatusData,
        linkInBodyCount: Math.min(linkInBodyCount, MAX_NUMBER_OF_LINKS_TO_LOG),
        newLinkCount: Math.min(newLinkCount, MAX_NUMBER_OF_LINKS_TO_LOG),
    });
}
